import '../../app/styles/index.css'

import React from 'react'
import { ThemeProvider } from '@mui/material'
import { BrowserRouter as Router } from 'react-router-dom'

import { Box, Container, theme } from 'common'
import { Routing } from 'pages'
import { Footer } from 'widgets/footer'
import { Header } from 'widgets/header'
import { FaqBot } from 'widgets/faqBot'

import AccessibilityModal from 'a11y/AccessibilityModal'
import A11yHotkeyToast from 'a11y/A11yHotkeyToast'
import { useA11yTts } from 'a11y/useA11yTts'

export const Layout = () => {
  const [a11yOpen, setA11yOpen] = React.useState(false)

  const lang = (localStorage.getItem('appLanguage') || 'ru') as 'ru' | 'en' | 'kz'

  const ttsEnabled = localStorage.getItem('a11yTts') === '1'

  useA11yTts(ttsEnabled, {
    i18nLang: lang === 'kz' ? 'kk' : lang
  })

  /* ⌨️ Ctrl + U / Cmd + U */
  React.useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      const isMac = navigator.platform.toUpperCase().includes('MAC')
      const isCtrlOrCmd = isMac ? e.metaKey : e.ctrlKey
      const isU = e.code === 'KeyU'

      if (isCtrlOrCmd && isU) {
        e.preventDefault()
        e.stopPropagation()
        setA11yOpen(v => !v)
      }
    }

    window.addEventListener('keydown', onKeyDown, true)
    return () => window.removeEventListener('keydown', onKeyDown, true)
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <div className="app-shell" style={{ minHeight: '100vh' }}>
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header onOpenA11y={() => setA11yOpen(true)} />

            <Container maxWidth="xl" style={{ flex: 1 }}>
              <Box>
                <Routing />
              </Box>
            </Container>

            <Footer />
          </div>

          {/* ✅ ПОКАЗЫВАЕТСЯ ПРИ ЗАХОДЕ НА САЙТ */}
          <A11yHotkeyToast />
        </div>

        <AccessibilityModal
          open={a11yOpen}
          onClose={() => setA11yOpen(false)}
          lang={lang}
        />
        <FaqBot />
      </Router>
    </ThemeProvider>
  )
}
